module.exports = __webpack_public_path__ + "static/media/2.question_loop.259a09e6.mp4";